import PropTypes from 'prop-types';

import classes from './AditionalMaterialLesson.module.css';

const AditionalMaterialLesson = props => {
  return (
    <>
      {props.lessonMaterial.material && (
        <aside className={classes.lessonDescription}>
          {props.lessonMaterial.material.map(material => (
            <p
              key={material.materialName}
              className={classes.aditionalMaterialName}
            >
              <figure className={classes.productIcon}>
                <img
                  className={classes.img}
                  src="https://d1g6c01s9ssd7h.cloudfront.net/img/Documento_icon.png"
                />
              </figure>
              <span className={classes.productContentItemText}>
                {material.materialName}
              </span>
            </p>
          ))}
        </aside>
      )}
    </>
  );
};

AditionalMaterialLesson.propTypes = {
  // eslint-disable-next-line react/require-default-props
  lessonMaterial: PropTypes.array
};

export default AditionalMaterialLesson;
